// extracted by mini-css-extract-plugin
export default {"textPlaceholder":"styles-module__textPlaceholder__src-labstep-web-core-Text-Placeholder-__z0C0","clickable":"styles-module__clickable__src-labstep-web-core-Text-Placeholder-_IKP5C"};